var Severity;
(function (Severity) {
  Severity["secondary"] = "secondary";
  Severity["success"] = "success";
  Severity["info"] = "info";
  Severity["warning"] = "warning";
  Severity["danger"] = "danger";
  Severity["help"] = "help";
  Severity["contrast"] = "contrast";
})(Severity || (Severity = {}));

export { Severity };
